"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _Icon = _interopRequireDefault(require("../../icons/Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var StyledSelect = (0, _styledComponents["default"])(_reactSelect["default"]).withConfig({
  displayName: "BestSelect__StyledSelect",
  componentId: "wsqpry-0"
})(["&&&{div{", ";}}"], function (props) {
  return props.invalid && !props.isDisabled ? "border-color: red" : "";
});
var DropdownIcon = (0, _styledComponents["default"])(_Icon["default"]).attrs(function () {
  return {
    iconName: "fa-caret-down"
  };
}).withConfig({
  displayName: "BestSelect__DropdownIcon",
  componentId: "wsqpry-1"
})(["&&&{margin-right:0.9rem;color:#a9a9a9;}"]);

var IndicatorSeparator = function IndicatorSeparator(_ref) {
  var innerProps = _ref.innerProps;
  return _react["default"].createElement("span", _extends({
    style: {
      display: "none"
    }
  }, innerProps));
};

IndicatorSeparator.propTypes = {
  innerProps: _propTypes["default"].object.isRequired
};

var DropdownIndicator = function DropdownIndicator() {
  return _react["default"].createElement(DropdownIcon, null);
};

var BestSelect = function BestSelect(_ref2) {
  var name = _ref2.name,
      className = _ref2.className,
      id = _ref2.id,
      placeholder = _ref2.placeholder,
      portal = _ref2.portal,
      components = _ref2.components,
      isDisabled = _ref2.isDisabled,
      clearable = _ref2.clearable,
      styles = _ref2.styles,
      rest = _objectWithoutProperties(_ref2, ["name", "className", "id", "placeholder", "portal", "components", "isDisabled", "clearable", "styles"]);

  var Theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var _container = styles.container,
      placeHolderStyles = styles.placeholder,
      _multiValueRemove = styles.multiValueRemove,
      _menu = styles.menu,
      _menuPortal = styles.menuPortal,
      control = styles.control,
      _valueContainer = styles.valueContainer,
      _indicatorsContainer = styles.indicatorsContainer,
      _dropdownIndicator = styles.dropdownIndicator,
      _clearIndicator = styles.clearIndicator,
      _singleValue = styles.singleValue;
  var Styles = {
    container: function container(selectStyles) {
      return _objectSpread({}, selectStyles, {}, _container);
    },
    placeholder: function placeholder(selectStyles) {
      return _objectSpread({}, selectStyles, {}, placeHolderStyles, {
        fontStyle: "italic",
        fontColor: Theme["grey"]
      });
    },
    multiValueRemove: function multiValueRemove(selectStyles) {
      return _objectSpread({}, selectStyles, {}, _multiValueRemove, {
        color: Theme.link["color"],
        "&:hover": {
          color: Theme.link["hover"],
          backgroundColor: Theme["grey-three"]
        }
      });
    },
    menu: function menu(selectStyles) {
      return _objectSpread({}, selectStyles, {}, _menu, {
        zIndex: 2000
      });
    },
    menuPortal: function menuPortal(selectStyles) {
      return _objectSpread({}, selectStyles, {}, _menuPortal, {
        zIndex: 2050
      });
    },
    valueContainer: function valueContainer(selectStyles) {
      return _objectSpread({}, selectStyles, {}, _valueContainer);
    },
    indicatorsContainer: function indicatorsContainer(selectStyles) {
      return function () {
        return _objectSpread({}, selectStyles, {}, _indicatorsContainer, {
          padding: 0,
          color: "red"
        });
      };
    },
    dropdownIndicator: function dropdownIndicator(selectStyles) {
      return function () {
        return _objectSpread({}, selectStyles, {}, _dropdownIndicator, {
          color: "red"
        });
      };
    },
    clearIndicator: function clearIndicator(selectStyles) {
      return function () {
        return _objectSpread({}, selectStyles, {}, _clearIndicator);
      };
    },
    singleValue: function singleValue(selectStyles) {
      return function () {
        return _objectSpread({}, selectStyles, {}, _singleValue);
      };
    }
  };

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      focus = _useState2[0],
      setFocus = _useState2[1];

  var toggleFocus = function toggleFocus() {
    setFocus(!focus);
  };

  var invalid = className.includes("is-invalid");
  var selectComponents = Object.assign({}, {
    IndicatorSeparator: IndicatorSeparator,
    DropdownIndicator: DropdownIndicator
  }, components);
  var selectId = "best-select-" + id;
  var BorderTheme = Theme["border"];
  var shadowTheme = Theme["boxShadow"];

  if (!focus) {
    Styles.control = function (selectStyles) {
      return _objectSpread({}, selectStyles, {
        minWidth: 100
      }, control);
    };
  } else {
    Styles.control = function (selectStyles) {
      return _objectSpread({}, selectStyles, {
        minWidth: 100,
        backgroundColor: Theme["focus-color"],
        //Matching bootstrap on focus styles for inputs
        boxShadow: "0 0 0 0.2rem " + (invalid ? shadowTheme["invalid"] : shadowTheme["valid"]),
        borderColor: invalid ? BorderTheme["invalid"] : BorderTheme["valid"]
      }, control);
    };
  }

  if (rest.isMulti) {
    if (!rest.value) {
      if (rest.values) {
        rest.value = rest.values;
        delete rest.values;
      } else if (!rest.value) {
        rest.value = [];
      }
    }

    rest.defaultValue = rest.value;
  } else if (!rest.value) {
    rest.value = {};
  }

  return _react["default"].createElement(StyledSelect, _extends({}, rest, {
    styles: Styles,
    invalid: invalid,
    components: selectComponents,
    name: name,
    id: selectId,
    placeholder: placeholder,
    isDisabled: isDisabled,
    onFocus: function onFocus(event) {
      toggleFocus(event);
    },
    onBlur: function onBlur(event) {
      toggleFocus(event);
    },
    menuPortalTarget: portal,
    isClearable: clearable
  }));
};

BestSelect.propTypes = {
  /** name of the select */
  name: _propTypes["default"].string,

  /** options to display in the select */
  options: _propTypes["default"].array.isRequired,

  /** value of the select */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object, _propTypes["default"].array]).isRequired,

  /** ID to display */
  id: _propTypes["default"].string,

  /** placeholder for the select */
  placeholder: _propTypes["default"].string,

  /** menu portal target */
  portal: _propTypes["default"].object,

  /** if the input is disbaled */
  isDisabled: _propTypes["default"].bool,

  /** If the select is a multi select */
  isMulti: _propTypes["default"].bool,

  /** backspace removed */
  backspaceRemoves: _propTypes["default"].bool,

  /** Delete removes the values */
  deleteRemoves: _propTypes["default"].bool,

  /** is the select clearable */
  clearable: _propTypes["default"].bool,

  /** overrideable styles object from the react-select library */
  styles: _propTypes["default"].object,

  /** class names to pass to the component */
  className: _propTypes["default"].string,

  /** React-Select components */
  components: _propTypes["default"].object
};
BestSelect.defaultProps = {
  clearable: false,
  backspaceRemoves: false,
  deleteRemoves: false,
  id: "best-select",
  className: "",
  placeholder: "",
  name: "best-select",
  portal: null,
  isDisabled: false,
  isMulti: false,
  styles: {
    control: {},
    container: {},
    placeholder: {},
    multiValueRemove: {},
    menu: {},
    menuPortal: {},
    indicatorsContainer: {},
    dropdownIndicator: {},
    clearIndicator: {},
    singleValue: {}
  },
  components: null
};
var _default = BestSelect;
exports["default"] = _default;